import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import VueYoutube from "vue-youtube";
import router from "./router/index.js";
import store from "./store";

Vue.config.productionTip = false;

Vue.use(VueYoutube);

new Vue({
  vuetify,
  render: (h) => h(App),
  store,
  router,
}).$mount("#app");
